import {
  Directive,
  effect,
  inject,
  isDevMode,
  OnDestroy,
  OutputRefSubscription,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ColorPickerComponent } from './color-picker.component';

@Directive({
  selector:
    'sd-color-picker[formControl], sd-color-picker[formControlName], sd-color-picker[ngModel]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ColorPickerFormDirective,
      multi: true,
    },
  ],
})
export class ColorPickerFormDirective implements ControlValueAccessor, OnDestroy {
  private readonly host = inject(ColorPickerComponent);

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};
  private colorChangedRef: OutputRefSubscription;

  constructor() {
    effect(() => {
      const inputColor = this.host.color();

      if (isDevMode() && inputColor !== undefined) {
        throw new Error(
          'ColorPickerDirective: ' +
            "Mixed usage. Don't use the [color] input and [formControl] together.",
        );
      }
    });

    this.colorChangedRef = this.host.colorChanged.subscribe((value: string) => {
      this.onChange(value);
      this.onTouched();
    });
  }

  ngOnDestroy(): void {
    this.colorChangedRef.unsubscribe();
  }

  writeValue(value: any): void {
    this.host.setInternalColorValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.host.setDisabledState(isDisabled);
  }
}
